import React from 'react';

import { StarFilled } from '../../icons/StarFilled';
import { StarOutlined } from '../../icons/StarOutlined';
import { StarPending } from '../../icons/StarPending';
import { IconSize } from '../../icons/SvgIcon';

export type StarVariant = 'filled' | 'outlined' | 'pending';
export type Props = {
  size?: IconSize;
  variant: StarVariant;
};

export function Star(props: Props): JSX.Element {
  const { size, variant } = props;

  const getStarIcon = (): JSX.Element => {
    if (variant === 'filled') {
      return <StarFilled size={size} testId="star-filled" />;
    }

    if (variant === 'pending') {
      return <StarPending size={size} testId="star-pending" />;
    }

    return <StarOutlined size={size} testId="star-outlined" />;
  };

  return getStarIcon();
}
